import { formatSpeakerToSave } from '@app/modules/logger/screens/stream/components/audit/transcriptions/utils';
import { DateTimeStr } from '@mi-front/core';
import { SpeakerInput } from './SpeakerInput';
import { useEditor } from './useEditor';

interface SpeakerEditorProps {
  voice_label?: string;
  fragmentId: string;
  time: DateTimeStr;
  segment: { start: number; end: number };
  distance: number;
  label: string;
  onReplaceAll: (new_voice_label: string, label: string) => void;
}

export function SpeakerEditor({
  voice_label,
  fragmentId,
  time,
  distance,
  segment,
  label,
  onReplaceAll,
}: SpeakerEditorProps) {
  const { handleUpdateSpeaker } = useEditor();

  if (!voice_label) {
    return null;
  }

  const handleSave = async (new_voice_label: string) => {
    await handleUpdateSpeaker(fragmentId, time, [
      {
        distance: distance,
        segment: segment,
        label: label,
        voice_label: formatSpeakerToSave(new_voice_label),
      },
    ]);
  };

  return (
    <SpeakerInput
      speaker={voice_label}
      onSave={(word) => handleSave(word)}
      onReplaceAll={onReplaceAll}
    />
  );
}
